import React, { useState, Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import { Link, navigate } from "gatsby";

// Components
import NavbarMenu from "../NavbarMenu";
import { links } from "../../../data";

// CSS
import "./Navbar.css";

const Index = () => {
  const [pageScrolled, setPageScrolled] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const services = [
    {
      path: "/services/software-development/",
      title: "Software development",
    },
    {
      path: "/services/mvp-development/",
      title: "MVP development",
    },
    {
      path: "/services/design-and-development/",
      title: "Web design & development",
    },
    {
      path: "/services/ai-solutions/",
      title: "AI & Open AI solutions",
    },
    {
      path: "/services/blockchain-solutions/",
      title: "Blockchain solutions",
    },
  ];

  const handleCloseDropdown = () => {
    setOpenDropdown(false);
  };

  const handleOpenDropdown = () => {
    setOpenDropdown(true);
  };

  React.useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 60) {
        setPageScrolled(true);
      } else {
        setPageScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
  }, [pageScrolled]);

  return (
    <div className="fixed-top">
      <nav
        className={`navbar navbar-expand-lg ${
          pageScrolled
            ? "py-sm-3 bg-white navbar-light shadow-sm"
            : "py-sm-5 bg-transparent navbar-dark"
        }`}
      >
        <div className="container">
          <Link
            className={`navbar-brand logo-image my-3 ${
              pageScrolled ? "text-black" : "text-white"
            }`}
            to="/"
            role="button"
          />
          <div className="navbar-toggler p-0 border-0">
            <NavbarMenu pageScrolled={pageScrolled} />
            <span className="social-icons ms-2 my-0">
              <span className="fa-stack my-0">
                <a
                  href="https://www.linkedin.com/in/hanzala-/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="linkedin-btn"
                >
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fab fa-linkedin fa-stack-1x"></i>
                  <span hidden>Twitter</span>
                </a>
              </span>
              <span className="fa-stack my-0">
                <a
                  href="https://twitter.com/justhanzala"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="twitter-btn"
                >
                  <span hidden>Twitter</span>
                  <i className="fas fa-circle fa-stack-2x" />
                  <i className="fab fa-twitter fa-stack-1x" />
                </a>
              </span>
            </span>
          </div>

          <div className="collapse navbar-collapse">
            <ul className="navbar-nav my-0 ms-auto">
              {links.map((link, index) => (
                <li className="nav-item px-3" key={index}>
                  {link.dropdown ? (
                    <Popover
                      className="position-relative"
                      onMouseEnter={handleOpenDropdown}
                      onMouseLeave={handleCloseDropdown}
                    >
                      <Fragment>
                        <Popover.Button
                          as={Link}
                          className={`nav-link fs-4`}
                          onClick={() => {
                            navigate(link.to);
                            handleCloseDropdown();
                          }}
                          activeClassName="bold"
                          to={link.to}
                        >
                          {link.title}
                        </Popover.Button>
                        <Transition
                          as={Fragment}
                          show={openDropdown}
                          enter="enter-active"
                          enterFrom="enter"
                          enterTo="enter-to"
                          leave="leave-active"
                          leaveFrom="leave"
                          leaveTo="leave-to"
                        >
                          <Popover.Panel
                            className="position-absolute start-0 z-3"
                            onClick={handleCloseDropdown}
                            style={{ top: "36px" }}
                          >
                            <ul className="bg-white rounded shadow list-unstyled py-2">
                              {services.map(({ title, path }, index) => (
                                <li key={index}>
                                  <Link
                                    className="fs-6 d-block w-100 text-nowrap text-black fst-normal text-decoration-none px-3 py-2 mb-1 text-capitalize"
                                    activeClassName="bg-blue text-white"
                                    to={path}
                                  >
                                    {title}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </Popover.Panel>
                        </Transition>
                      </Fragment>
                    </Popover>
                  ) : (
                    <Link
                      className="nav-link fs-4"
                      activeClassName="active"
                      to={link.to}
                    >
                      {link.title}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Index;
